import { Map as iMap } from 'immutable';
const initialState = iMap({
  isSynced: false,
  totalCount: 0,
  pendingRequestCount: 0,
  pendingInviteCount: 0,
  shouldShow: true,
});

export function connectionsStats(state = initialState, action) {
  switch (action.type) {
    case 'CLEAR_STORES':
      return initialState;
    case 'REFRESH_CONNECTIONS_STATS':
      return state.merge(action.payload).set('isSynced', true);
    // case 'FILTER_CONNECTIONS':
    //   return state.merge(action.payload);
    case 'ACCEPT_CONNECTION_STARTING':
      return state
              .set('oldState', state)
              .set('totalCount', state.get('totalCount') + 1)
              .set('pendingRequestCount', state.get('pendingRequestCount') - 1);
    case 'IGNORE_CONNECTION_STARTING':
      return state
        .set('oldState', state)
        .set('pendingRequestCount', state.get('pendingRequestCount') - 1);
    case 'REMOVE_CONNECTION_STARTING':
      return state
        .set('oldState', state)
        .set('totalCount', state.get('totalCount') - 1);
    case 'UNDO_CONNECTION_CHANGE':
      return state.get('oldState');
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/connections-stats/connections-stats-reducer.js